function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';
const colors = {
  green: '#daf0ed',
  pink: '#f9c3c7',
  yellow: '#FDF5BF'
};

function Document({
  color,
  size,
  outline,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 30 31"
  }, rest), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(4 1)"
  }, !outline && /*#__PURE__*/React.createElement("path", {
    fill: colors[color],
    d: "M21.14 8.36L21.315 8.544 21.315 29.355 0.56 29.291 0.56 0.653 13.848 0.653 17.016 4.001 21.375 8.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828A90",
    d: "M21.836,13.887 C21.8233333,12.871 21.799,11.855 21.763,10.839 C21.7436667,10.339 21.722,9.839 21.698,9.339 C21.697102,9.08872609 21.6790597,8.83880769 21.644,8.591 L21.638,8.572 C21.6481913,8.47347324 21.616637,8.37518336 21.551,8.301 C21.5153725,8.21991033 21.4718281,8.14253524 21.421,8.07 C21.1623392,7.74595638 20.8855642,7.43679636 20.592,7.144 C20.268,6.79 19.935,6.444 19.598,6.105 C18.936,5.434 18.259,4.777 17.614,4.089 C17.138,3.583 16.66,3.08033333 16.18,2.581 C15.723428,2.14240914 15.2895306,1.68080912 14.88,1.198 C14.7013518,0.946039374 14.4913273,0.717868663 14.255,0.519 C14.159782,0.44614214 14.0538617,0.388459463 13.941,0.348 C13.9263686,0.341955418 13.9113318,0.336943151 13.896,0.333 C13.6472683,0.273980573 13.3909115,0.253741885 13.136,0.273 C12.822,0.273 12.505,0.266 12.19,0.266 L0.562,0.266 C0.349613246,0.269218533 0.178218533,0.440613246 0.175,0.653 C0.175,10.2003333 0.172,19.7473333 0.166,29.294 C0.168737198,29.5129588 0.347024082,29.6890171 0.566,29.689 C7.48266667,29.7176667 14.4,29.7386667 21.318,29.752 C21.5389139,29.752 21.718,29.5729139 21.718,29.352 C21.718,26.778 21.764,24.203 21.804,21.629 C21.844,19.055 21.869,16.468 21.836,13.887 Z M14.526,2 C15.366,2.886 16.203,3.777 17.053,4.653 C18.098,5.731 19.094,6.918 20.174,7.983 C18.266,7.81 16.26,7.945 14.366,7.963 C14.366,5.922 14.38,3.879 14.366,1.838 C14.421,1.89 14.477,1.944 14.526,2 Z M20.621,28.956 C18.9113187,29.0788128 17.1948307,29.0731301 15.486,28.939 L8.2,28.912 C6.23266667,28.904 4.266,28.9 2.3,28.9 C1.86080854,28.9489168 1.41867597,28.9662947 0.977,28.952 C0.988070457,28.7849978 0.980355466,28.6172806 0.954,28.452 C0.863326587,27.0495164 0.861656571,25.642695 0.949,24.24 C0.945,19.4666667 0.945,14.6933333 0.949,9.92 C0.949,7.53333333 0.949,5.14633333 0.949,2.759 C0.949,2.443 0.81,0.952 0.675,1.04 C0.940187194,1.00027465 1.20981281,1.00027465 1.475,1.04 L13.579,1.04 C13.547,3.481 13.572,5.923 13.573,8.363 C13.573,8.5839139 13.7520861,8.763 13.973,8.763 C16.2823135,8.8841597 18.5971447,8.85075183 20.902,8.663 L20.97,8.724 C20.735,12.93 20.926,17.2 20.924,21.413 C20.924,23.483 20.724,25.673 20.924,27.734 C21.047,29.073 21.632,28.8 20.621,28.953 L20.621,28.956 Z"
  })));
}

Document.defaultProps = {
  color: 'green',
  outline: false,
  size: '15'
};
Document.propTypes = {
  color: PropTypes.oneOf(['green', 'pink']),
  outline: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default Document;